module.exports = __webpack_public_path__ + "media/svg/br-e01c0bc8.svg";